import { FunctionComponent, useState } from 'react';
import PaperLayout from '../layout/PaperLayout';
import { BookingsSortOrder, EXPORT_BOOKINGS_EXPLANATION } from './bookingConstants';
import { useArchivedBookings } from './bookingService';
import BookingList from './components/BookingList';

const BookingArchive: FunctionComponent = () => {
    const [assetId, setAssetId] = useState<string | undefined>();
    const { bookings, isLoading, refetch } = useArchivedBookings(assetId);

    return (
        <PaperLayout heading="Bokningshistorik" preamble={<p>{EXPORT_BOOKINGS_EXPLANATION}</p>}>
            <BookingList
                bookings={bookings}
                defaultSortDirection="descending"
                defaultSortOrder={BookingsSortOrder.Date}
                filterNoBookingsHeading="Hoppsan! Här var det tomt"
                filterNoBookingsText="Just nu finns inga arkiverade bokningar för den valda resursen. När den bokats kommer det synas här."
                hasAssetFilter={!!assetId}
                isArchived={true}
                isLoading={isLoading}
                noBookingsHeading="Här visas tidigare bokningar"
                noBookingsText="Just nu finns inga bokningar i arkivet. När en resurs nyttjats kommer det synas här."
                onAssetFilterChange={setAssetId}
                refetch={refetch}
            />
        </PaperLayout>
    );
};

export default BookingArchive;
